/* Modello footer: insigna «Înapoi sus» derulează pagina până la hero. Pe desktop pagina se derulează într-un container, nu fereastra. */
(function () {
  function scroller(from) {
    var p = from.parentElement;
    while (p && p !== document.body && p !== document.documentElement) {
      var s = getComputedStyle(p);
      if (/(auto|scroll)/.test(s.overflowY) && p.scrollHeight > p.clientHeight + 4) return p;
      p = p.parentElement;
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-mf-up]') : null;
    if (!a) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var opts = { top: 0, behavior: reduce ? 'auto' : 'smooth' };
    var sc = scroller(a);
    if (sc) sc.scrollTo(opts);
    window.scrollTo(opts);
  });
})();
